function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "pressTitle"
}, "press");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.71972 0.76972 28.9912 0.76972 28.9912 29.04132 0.71972 29.04132"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "45 148.8304 134.7912 148.8304 134.7912 32.8 45 32.8"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "MP_for_a_Week_Assets",
  transform: "translate(-952.000000, -1064.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Detailed_Icon_Press",
  transform: "translate(952.000000, 1064.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-21",
  x: 0,
  y: 0,
  width: 180,
  height: 180
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(105.800000, 32.030400)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.85072,24.90072 C19.33072,30.42152 10.38032,30.42152 4.86032,24.90072 C-0.66048,19.38072 -0.66048,10.43032 4.86032,4.91032 C10.38032,-0.61048 19.33072,-0.61048 24.85072,4.91032 C30.37152,10.43032 30.37152,19.38072 24.85072,24.90072",
  id: "Fill-1",
  fill: "#5F5984",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M120.70032,56.93112 C115.18032,51.41112 115.18032,42.46072 120.70032,36.93992 C122.16032,35.48072 123.86272,34.41752 125.67552,33.73032 C120.63392,31.81752 114.72032,32.87992 110.66032,36.93992 C105.13952,42.46072 105.13952,51.41112 110.66032,56.93112 C114.72032,60.99192 120.63392,62.05352 125.67552,60.14072 C123.86272,59.45352 122.16032,58.39112 120.70032,56.93112",
  id: "Fill-4",
  fill: "#4F4978"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-7"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-6",
  fill: "#D2CFDD",
  mask: "url(#mask-4)",
  points: "82.8416 148.8304 91.5176 148.8304 91.5176 87.6328 82.8416 87.6328"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-8",
  fill: "#4F4978",
  mask: "url(#mask-4)",
  points: "80.2304 119.6744 94.1296 119.6744 94.1296 106.8552 80.2304 106.8552"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-9",
  fill: "#5F5984",
  mask: "url(#mask-4)",
  points: "57.86872 122.59128 44.99992 109.72248 97.31272 57.40968 110.18152 70.27848"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-10",
  fill: "#D2CFDD",
  mask: "url(#mask-4)",
  points: "112.73432 72.83112 94.75992 54.85672 103.91512 45.70232 121.88872 63.67672"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-11",
  fill: "#4F4978",
  mask: "url(#mask-4)",
  points: "44.99992 109.72248 57.86872 122.59128 87.92632 92.53368 62.18872 92.53368"
}))));

var SvgDetailedIconPress = function SvgDetailedIconPress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "180px",
    height: "180px",
    viewBox: "0 0 180 180",
    "aria-labelledby": "pressTitle",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "pressTitle"
  }, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDetailedIconPress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/detailed-icon-press.cf50ec19.svg";
export { ForwardRef as ReactComponent };